(function () {
  if (window.shtoInfoTabsJs) return;
  window.shtoInfoTabsJs = true;
  var SLICK = { speed: 300, arrows: false, autoplay: false, infinite: true, dots: true, slidesToShow: 2, slidesToScroll: 2 };

  function headerHeight() {
    var header = document.getElementById('header');
    if (!header) return 0;
    var position = getComputedStyle(header).position;
    if (position !== 'fixed' && position !== 'sticky') return 0;
    return Math.round(header.getBoundingClientRect().height);
  }

  function slick(panel) {
    if (panel.hidden || panel.getAttribute('data-view') !== 'ingredients') return;
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick) return;
    var $grid = $(panel).find('.ingredientsList-product .itemGrid-sliderEnabled');
    if (!$grid.length) return;
    if ($grid.hasClass('slick-initialized')) { $grid.slick('setPosition'); return; }
    if ($grid.find('.gridItem').length > 1) $grid.slick(SLICK);
  }

  function load(panel) {
    var state = panel.getAttribute('data-state');
    if (state === 'loading') return;
    // Already there (a Key Ingredients list printed on the page from the ingredients blog): just run their slider on it.
    if (state === 'loaded') { slick(panel); return; }
    panel.setAttribute('data-state', 'loading');
    panel.setAttribute('aria-busy', 'true');
    fetch(panel.getAttribute('data-url'), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        panel.querySelector('.shto-info-tabs__content').innerHTML = html;
        panel.setAttribute('data-state', 'loaded');
        panel.removeAttribute('aria-busy');
        slick(panel);
      })
      .catch(function () {
        panel.setAttribute('data-state', 'error');
        panel.removeAttribute('aria-busy');
      });
  }

  function panelFor(tab) {
    return document.getElementById(tab.getAttribute('aria-controls'));
  }

  function open(root, tab, focus) {
    var tabs = root.querySelectorAll('.shto-info-tabs__tab');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i] === tab;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', on ? '0' : '-1');
      tabs[i].classList.toggle('is-active', on);
      var panel = panelFor(tabs[i]);
      if (panel) panel.hidden = !on;
    }
    if (focus) tab.focus({ preventScroll: focus === 'quiet' });
    var current = panelFor(tab);
    if (!current) return;
    if (current.getAttribute('data-state') === 'loaded') slick(current);
    else load(current);
  }

  function init(root) {
    if (root.shtoInfoTabs) return;
    root.shtoInfoTabs = true;
    var list = root.querySelector('.shto-info-tabs__list');
    if (!list) return;

    list.addEventListener('click', function (event) {
      var tab = event.target.closest('.shto-info-tabs__tab');
      if (tab) open(root, tab, false);
    });
    list.addEventListener('keydown', function (event) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll('.shto-info-tabs__tab'));
      var index = tabs.indexOf(document.activeElement);
      if (index < 0) return;
      var next = null;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      open(root, next, true);
    });
    root.addEventListener('click', function (event) {
      var retry = event.target.closest('.shto-info-tabs__retry');
      if (!retry) return;
      var panel = retry.closest('.shto-info-tabs__panel');
      panel.setAttribute('data-state', 'idle');
      load(panel);
    });

    var setMargin = function () { root.style.scrollMarginTop = headerHeight() + 'px'; };
    setMargin();
    window.addEventListener('resize', setMargin, { passive: true });

    var loadFirst = function () {
      var active = root.querySelector('.shto-info-tabs__tab[aria-selected="true"]');
      var panel = active && panelFor(active);
      if (panel) load(panel);
    };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { observer.disconnect(); loadFirst(); return; }
        }
      }, { rootMargin: '800px 0px 800px 0px' });
      observer.observe(root);
    } else {
      loadFirst();
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-shto-info-tabs]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (!window.shtoInfoTabsLinks) {
    window.shtoInfoTabsLinks = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-shto-open-tab]');
      if (!link) return;
      var key = link.getAttribute('data-shto-open-tab');
      var tab = document.querySelector('[data-shto-info-tabs] .shto-info-tabs__tab[data-shto-tab="' + key + '"]');
      if (!tab) return;
      event.preventDefault();
      var root = tab.closest('[data-shto-info-tabs]');
      init(root);
      open(root, tab, 'quiet');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // The theme hides its fixed header while the page scrolls down and shows it while it scrolls up, so going down
      // the tabs land at the top of the screen and going up they land under the header (same as the hero button).
      var distance = root.getBoundingClientRect().top;
      var top = distance + window.pageYOffset - (distance < 0 ? headerHeight() : 0);
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    });
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (event) {
      var tab = event.target.closest && event.target.closest('[data-shto-info-tabs] .shto-info-tabs__tab');
      if (tab) open(tab.closest('[data-shto-info-tabs]'), tab, false);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
